import React, { useRef, useState } from "react";

export default function Controls({
  currentSong,
  playing,
  startSong,
  stopSong,
  prevSong,
  nextSong,
  changeVol,
}) {
  const [vol, setVol] = useState(50);

  const changeVolume=(e)=>{
    setVol(e.target.value)
    console.log(vol/100)
    changeVol(vol/100)
  }

  return (
    <div className="controls">
      <div className="volume-bar">
        <button onClick={() => prevSong()}>
          <i className="bi bi-volume-down secondary-icon"></i>
        </button>
        <input
          type="range"
          max={100}
          min={0}
          value={vol}
          onChange={(e) => changeVolume(e)}
          className="slider"
        />
        <button onClick={() => prevSong()}>
          <i className="bi bi-volume-up secondary-icon"></i>
        </button>
      </div>
      <div className="song-controls">
        <button onClick={() => prevSong()}>
          <i className="bi bi-skip-backward secondary-icon"></i>
        </button>
        {playing ? (
          <button onClick={() => stopSong()}>
            <i className="bi bi-pause-circle app-icon"></i>
          </button>
        ) : (
          <button onClick={() => startSong()}>
            <i className="bi bi-play-circle app-icon "></i>
          </button>
        )}
        <button onClick={() => nextSong()}>
          <i className="bi bi-skip-forward secondary-icon"></i>
        </button>
      </div>
    </div>
  );
}
